module.exports = "https://trybtryb-legacy.web.app/img/own-your-audience.9ab3dc1d.webp";